import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';

const VerifyPhoneNumberBanner = () => {
  const { t } = useTranslation('app');
  const { MY_ACCOUNT_URL } = useFullRoutes();

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-black z-20 bg-opacity-80 ">
      <div className="bg-orange_light_2 px-4x md:px-10x">
        <div className="container py-4x">
          <p className="text-title_4 flex gap-1">
            <span>{t('confirmPhoneNumberMessage')}</span>
            <Link
              to={MY_ACCOUNT_URL.SETTINGS_AND_PRIVACY}
              className="text-blue"
            >
              {t('mySettings')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhoneNumberBanner;
